import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getStep5ReportData, getStep5InterventionList } from 'js/reducers/egto.js';
import Loader from 'cccisd-loader';
import Player from './player.js';
import { useMetricspawnQuery } from 'js/queries';

const Component = props => {
    const reduxStore = useSelector(state => state.app.egto);
    const dispatch = useDispatch();
    const metricspawnQuery = useMetricspawnQuery();
    const metricspawn = metricspawnQuery?.data?.descendantRoles?.metricspawn?.pawn;

    useEffect(() => {
        if (metricspawnQuery.status === 'success') {
            (async () => {
                const findDeploymentId = () => {
                    if (props.deploymentId) {
                        return props.deploymentId;
                    }
                    if (reduxStore.currentDeployment) {
                        return reduxStore.currentDeployment.deploymentId;
                    }
                    return 3;
                };
                await dispatch(getStep5ReportData(findDeploymentId(), metricspawn));
            })();
        }
    }, [metricspawnQuery.status]);

    useEffect(() => {
        if (reduxStore.step5ReportDataLoaded) {
            dispatch(getStep5InterventionList(reduxStore.step3InterventionList, reduxStore.step5ReportData));
            // setInterventionList(reduxStore.step3InterventionList);
        }
    }, [reduxStore.step5ReportDataLoaded]);

    if (!reduxStore.step5ReportDataLoaded || metricspawnQuery.status === 'loading') {
        return <Loader loading />;
    }

    if (reduxStore.step5InterventionList.length > 0 && reduxStore.step5InterventionList[0].value !== '') {
        return (
            <Player
                {...props}
                interventionList={reduxStore.step5InterventionList}
                reportDataLoaded={reduxStore.step5ReportDataLoaded}
            />
        );
    }
    return null;
};

export default Component;
